import { Cushion, Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from '../../lib/i18n';
import PreviewFixture from './preview-fixture';

const HeadToHead = ({ fixtures }) => (
  <Rectangle
    fill="white"
    style={{ border: '1px solid #d9d9d9', overflow: 'hidden' }}
    responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
  >
    <Rectangle fill="#fafafa">
      <Cushion all="small">
        <Typography size={16} weight="bold" color="black" align="center" component="h3">
          <Trans i18nKey="teams:head_to_head_title">Head To Head</Trans>
        </Typography>
      </Cushion>
    </Rectangle>
    {fixtures.map((fixture, i) => {
      const data = {
        date: fixture.dateTime,
        homeTeamName: fixture.homeSide.name,
        homeScore: fixture.homeSide.score,
        homePrimary: fixture.homeSide.primaryColour,
        homeSecondary: fixture.homeSide.secondaryColour,
        awayTeamName: fixture.awaySide.name,
        awayScore: fixture.awaySide.score,
        awayPrimary: fixture.awaySide.primaryColour,
        awaySecondary: fixture.awaySide.secondaryColour,
        homeOrAway: fixture.ha,
      };
      return <PreviewFixture fixture={data} isLast={i === fixtures.length} />;
    })}
  </Rectangle>
);

HeadToHead.defaultProps = {
  fixtures: [],
};

HeadToHead.propTypes = {
  fixtures: PropTypes.arrayOf(PropTypes.shape({})),
};

export default HeadToHead;
